import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class ArrisNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Arris...');
    return this.onlineByAjax();
  }

}

export default ArrisNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/arris/NetworkStatus.js